import { AppInitializationProvider } from '@/providers/app-initialization/app-initialization.provider';
import { Component, inject } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent {
    private _appInitializationProvider = inject(AppInitializationProvider);

    ngOnInit() {
        this._appInitializationProvider.notifyAppInitialization();
    }
}
